import { forwardRef, useCallback, useMemo, useState } from "react";
import classNames from "classnames";

import { CFormGroup, CInput, CLabel } from "@coreui/react";

import { EyeClose, EyeOpen, XCircleFill } from "_assets/icons";

function Input(
  { label, onChange, className, value, type, onEnter, ...rest },
  ref
) {
  const [isShow, setShow] = useState(false);

  const _class = classNames("c-input", className);

  const toggleShow = useCallback(() => setShow(!isShow), [isShow]);

  const change = useCallback((e) => onChange(e.target.value), [onChange]);

  const clear = useCallback((e) => {
    e.target.closest("div").querySelector("input").value = "";
    onChange("");
  }, []);

  const renderExtend = useMemo(
    () => () =>
      !!value && (
        <span className="extends">
          {type === "password" &&
            (isShow ? (
              <EyeOpen className="icon" onClick={toggleShow} />
            ) : (
              <EyeClose className="icon" onClick={toggleShow} />
            ))}
          <XCircleFill onClick={clear} />
        </span>
      ),
    [value, isShow]
  );

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      onEnter?.();
    }
  };

  return (
    <CFormGroup className={_class}>
      {label && (
        <CLabel>
          {label} {rest.required && <span className="text-danger">*</span>}
        </CLabel>
      )}
      <div className="input-wrapper">
        {type === "password" ? (
          <CInput
            innerRef={ref}
            type={isShow ? "text" : type}
            className="custom password"
            onChange={change}
            {...rest}
          />
        ) : (
          <CInput
            innerRef={ref}
            type={type}
            value={value || ""}
            className="custom input"
            onChange={change}
            onKeyDown={onKeyDown}
            {...rest}
          />
        )}
        {!rest.disabled &&
          !rest.readOnly &&
          type !== "number" &&
          renderExtend(value)}
      </div>
    </CFormGroup>
  );
}

export default forwardRef(Input);
